interface SparklineProps {
  data: (number | null)[];
  color?: string;
  height?: number;
}

export function Sparkline({ data, color = '#3b82f6', height = 30 }: SparklineProps) {
  const validData = data.filter(d => d !== null) as number[];

  if (validData.length === 0) {
    return <div className="text-xs text-gray-400">Pas de données</div>;
  }

  const min = Math.min(...validData);
  const max = Math.max(...validData);
  const range = max - min || 1;

  const width = 80;
  const padding = 2;

  const points = data.map((value, index) => {
    if (value === null) return null;
    const x = (index / (data.length - 1)) * (width - padding * 2) + padding;
    const y = height - padding - ((value - min) / range) * (height - padding * 2);
    return { x, y };
  }).filter(p => p !== null) as { x: number; y: number }[];

  if (points.length === 0) return null;

  const pathData = points.map((point, index) =>
    `${index === 0 ? 'M' : 'L'} ${point.x} ${point.y}`
  ).join(' ');

  return (
    <svg width={width} height={height} className="inline-block">
      <path
        d={pathData}
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {points.map((point, index) => (
        <circle
          key={index}
          cx={point.x}
          cy={point.y}
          r="2"
          fill={color}
        />
      ))}
    </svg>
  );
}
